import Route from '@ember/routing/route';
import { service } from '@ember/service';

export default class DeliveriesSettingsIndexRoute extends Route {
  @service router;

  beforeModel() {
    this.router.transitionTo('deliveries.settings.delivery-areas');
  }
}
